/**
 * One scroll lock for every overlay. Stops sideways page pan.
 */
(function () {
  'use strict';

  var locked = false;
  var lockY = 0;
  var raf = 0;

  function ageGateOpen() {
    var html = document.documentElement;
    if (html.classList.contains('ss-age-verified')) return false;
    var gate = document.getElementById('ss-age-gate');
    if (!gate) return false;
    if (gate.hasAttribute('hidden')) return false;
    if (gate.classList.contains('is-visible')) return true;
    if (gate.getAttribute('aria-hidden') === 'false') return true;
    var style = window.getComputedStyle(gate);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.pointerEvents !== 'none';
  }

  function overlayOpen() {
    var html = document.documentElement;
    var body = document.body;
    if (!body) return false;
    if (document.querySelector('cart-drawer.active')) return true;
    if (document.querySelector('.ss-search details[open]')) return true;
    if (document.querySelector('details.ss-drawer[open], .menu-drawer-container[open]')) return true;
    if (document.querySelector('.ss-qv.is-open')) return true;
    if (body.classList.contains('ss-club-open')) return true;
    if (body.classList.contains('ss-locator-open')) return true;
    if (body.classList.contains('ss-facets-open') && window.matchMedia('(max-width: 989px)').matches) return true;
    if (document.querySelector('#ss-chrome-header.ss-mega-open, .ss-chrome-header.ss-mega-open')) return true;
    if (ageGateOpen()) return true;
    var sheet = document.querySelector('.ss-locator__sheet');
    if (sheet && !sheet.hidden) return true;
    return false;
  }

  function applyLock() {
    if (locked) return;
    var html = document.documentElement;
    var body = document.body;
    if (!body) return;
    locked = true;
    lockY = window.scrollY || window.pageYOffset || 0;
    var sb = window.innerWidth - html.clientWidth;
    html.style.setProperty('--ss-scroll-lock-top', '-' + lockY + 'px');
    html.classList.add('ss-scroll-locked');
    body.classList.add('ss-scroll-locked', 'overflow-hidden');
    if (sb > 0) body.style.paddingRight = sb + 'px';
  }

  function releaseLock() {
    if (overlayOpen()) return;
    var html = document.documentElement;
    var body = document.body;
    var stuck = html.classList.contains('ss-scroll-locked') || html.classList.contains('ss-age-locked') || (body && (body.classList.contains('overflow-hidden') || body.classList.contains('ss-scroll-locked') || body.style.position === 'fixed'));
    if (!locked && !stuck) return;
    forceReleaseAll();
  }

  function closeTransientOverlays() {
    document.querySelectorAll('details.ss-drawer[open], .menu-drawer-container[open], .ss-search details[open], .ss-nav__details[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
    var header = document.getElementById('ss-chrome-header');
    if (header) header.classList.remove('ss-mega-open');
    document.querySelectorAll('.ss-chrome-header.ss-mega-open').forEach(function (el) {
      el.classList.remove('ss-mega-open');
    });
    var cart = document.querySelector('cart-drawer.active');
    if (cart) cart.classList.remove('active');
    if (document.body) {
      document.body.classList.remove('ss-club-open', 'ss-locator-open', 'ss-facets-open', 'ss-search-open', 'ss-drawer-open', 'overflow-hidden', 'ss-scroll-locked');
    }
    document.documentElement.classList.remove('ss-scroll-locked', 'ss-drawer-open', 'ss-search-open');
  }

  function forceReleaseAll() {
    var html = document.documentElement;
    var body = document.body;
    var wasLocked = locked || html.classList.contains('ss-scroll-locked') || (body && body.style.position === 'fixed');
    var y = window.scrollY || window.pageYOffset || 0;
    if (wasLocked && body && body.style.top) {
      var parsed = parseInt(body.style.top, 10);
      if (!isNaN(parsed)) y = Math.abs(parsed);
      else y = lockY || y;
    } else if (wasLocked) {
      y = lockY || y;
    }
    locked = false;
    lockY = 0;
    html.classList.remove('ss-scroll-locked', 'ss-age-locked');
    if (html.classList.contains('ss-age-verified') || !ageGateOpen()) {
      html.classList.remove('ss-age-pending');
    }
    html.style.removeProperty('overflow');
    html.style.removeProperty('--ss-scroll-lock-top');
    if (body) {
      body.classList.remove('ss-scroll-locked', 'overflow-hidden', 'ss-age-locked');
      body.style.removeProperty('padding-right');
      body.style.removeProperty('position');
      body.style.removeProperty('top');
      body.style.removeProperty('width');
      body.style.removeProperty('touch-action');
      body.style.removeProperty('overflow');
    }
    if (wasLocked) window.scrollTo(0, y);
  }

  function sync() {
    if (overlayOpen()) applyLock();
    else releaseLock();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      sync();
    });
  }

  document.addEventListener('toggle', schedule, true);
  document.addEventListener('ss:header-close-all', schedule);

  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('cart-drawer, .ss-qv, [data-ss-club], .ss-locator__sheet')) {
              obs.observe(node, { attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
            }
          });
        }
      });
      schedule();
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    obs.observe(document.body, { attributes: true, childList: true, attributeFilter: ['class'] });
    document.querySelectorAll('cart-drawer, details.ss-drawer, .menu-drawer-container, .ss-search details, .ss-qv, [data-ss-club], #ss-age-gate, #ss-chrome-header, .ss-locator__sheet').forEach(function (el) {
      obs.observe(el, { attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
    });
  }

  function boot() {
    observe();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  function onReturn() {
    if (!document.documentElement.classList.contains('ss-scroll-locked') && !overlayOpen()) {
      forceReleaseAll();
      return;
    }
    closeTransientOverlays();
    forceReleaseAll();
  }

  window.addEventListener('pageshow', onReturn);
  window.addEventListener('pagehide', function () {
    if (document.documentElement.classList.contains('ss-scroll-locked') || overlayOpen()) onReturn();
  });

  document.addEventListener('focusin', function (e) {
    var inMarquee = e.target && e.target.closest && e.target.closest('[data-seamless-loop], .ss-reviews__track, .ss-ticker');
    if (!inMarquee) return;
    var y = window.scrollY || window.pageYOffset || 0;
    requestAnimationFrame(function () {
      var now = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(now - y) > 30) window.scrollTo(0, y);
    });
  });

  window.addEventListener('resize', schedule, { passive: true });

  document.addEventListener('ss:age-verified', function () {
    forceReleaseAll();
    schedule();
  });

  window.ssSyncScrollLock = sync;
  window.ssForceReleaseScrollLock = forceReleaseAll;
  window.ssClearScrollLocks = function () {
    forceReleaseAll();
    sync();
  };
})();
